import { Star, Quote } from "lucide-react";
import { SectionHeading } from "@/components/landing/Reveal";
import { TESTIMONIALS } from "@/lib/site";

export const Testimonials = () => {
  const items = [...TESTIMONIALS, ...TESTIMONIALS];
  return (
    <section data-testid="testimonials-section" className="py-24 md:py-32 bg-slate-900 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <SectionHeading label="Wall of love" title="People who hated exercise now love this" sub="Join thousands of members who finally found a program that fits their real, messy, busy lives." />
      </div>
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 sm:w-32 bg-gradient-to-r from-slate-900 to-transparent z-10" aria-hidden="true" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 sm:w-32 bg-gradient-to-l from-slate-900 to-transparent z-10" aria-hidden="true" />
        <div className="flex w-max items-stretch gap-8 animate-marquee-slow hover:[animation-play-state:paused] px-4">
          {items.map((t, i) => (
            <figure key={i} {...(i < TESTIMONIALS.length ? { "data-testid": `testimonial-card-${i}` } : {})}
              className="w-[20rem] sm:w-[24rem] shrink-0 bg-slate-950 rounded-[2rem] p-8 border border-slate-800 shadow-[0_8px_30px_rgb(0,0,0,0.25)] transition-shadow duration-300 hover:shadow-[0_20px_40px_rgb(0,0,0,0.4)] flex flex-col">
              <Quote size={26} className="text-blue-500/40 mb-5" fill="currentColor" />
              <div className="flex gap-1 text-orange-500 mb-4" aria-label={`${t.stars} star review`}>
                {[...Array(t.stars)].map((_, s) => <Star key={s} size={15} fill="currentColor" />)}
              </div>
              <blockquote className="text-sm sm:text-base text-slate-300 leading-relaxed mb-6 flex-1">"{t.quote}"</blockquote>
              <figcaption className="flex items-center gap-3">
                <span className="w-11 h-11 rounded-full bg-orange-500 text-white flex items-center justify-center font-display font-bold text-sm">
                  {t.name.split(" ").map((n) => n[0]).join("")}
                </span>
                <div>
                  <p className="text-sm font-bold text-white">{t.name}</p>
                  <p className="text-xs text-slate-500">{t.tag}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
